import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useEffect, useState } from 'react';
import { Alert, Box, Chip, LinearProgress, Skeleton, Stack, Typography } from '@mui/material';
import { livyJson } from 'src/lib/livyApi';
export function FeedbackTab() {
  const _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    data = _useState2[0],
    setData = _useState2[1];
  const _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    error = _useState4[0],
    setError = _useState4[1];
  useEffect(() => {
    livyJson('/feedback').then(setData).catch(e => setError(e.message));
  }, []);
  if (error) return /*#__PURE__*/React.createElement(Alert, {
    severity: "error",
    sx: {
      mt: '16px'
    }
  }, error);
  if (!data) return /*#__PURE__*/React.createElement(Stack, {
    spacing: "8px",
    sx: {
      mt: '16px'
    }
  }, [0, 1, 2].map(i => /*#__PURE__*/React.createElement(Skeleton, {
    key: i,
    height: 40
  })));
  const total = data.counts.up + data.counts.down;
  const worst = data.recent.filter(r => r.rating === 'down');
  return /*#__PURE__*/React.createElement(Box, {
    sx: {
      pt: '16px'
    }
  }, total === 0 ? /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    color: "text.secondary"
  }, "No ratings yet. Thumbs appear under every answer Livy gives.") : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Stack, {
    direction: "row",
    spacing: "10px",
    sx: {
      mb: '20px',
      flexWrap: 'wrap',
      rowGap: '10px'
    }
  }, [{
    label: 'satisfaction',
    value: data.satisfaction === null ? '–' : "".concat(data.satisfaction, "%")
  }, {
    label: 'helpful',
    value: data.counts.up
  }, {
    label: 'not helpful',
    value: data.counts.down
  }].map(s => /*#__PURE__*/React.createElement(Box, {
    key: s.label,
    sx: {
      border: 1,
      borderColor: 'divider',
      borderRadius: '10px',
      px: '14px',
      py: '10px',
      minWidth: 108
    }
  }, /*#__PURE__*/React.createElement(Typography, {
    sx: {
      fontSize: 20,
      fontWeight: 600,
      lineHeight: 1.1
    }
  }, s.value), /*#__PURE__*/React.createElement(Typography, {
    sx: {
      fontSize: 11.5,
      color: 'text.secondary'
    }
  }, s.label)))), Object.keys(data.reasons).length > 0 && /*#__PURE__*/React.createElement(Box, {
    sx: {
      mb: '22px',
      maxWidth: 520
    }
  }, /*#__PURE__*/React.createElement(Typography, {
    sx: {
      fontSize: 13,
      fontWeight: 600,
      mb: '8px'
    }
  }, "Why"), Object.entries(data.reasons).sort((a, b) => b[1] - a[1]).map(_ref => {
    let _ref2 = _slicedToArray(_ref, 2),
      reason = _ref2[0],
      n = _ref2[1];
    return /*#__PURE__*/React.createElement(Box, {
      key: reason,
      sx: {
        mb: '8px'
      }
    }, /*#__PURE__*/React.createElement(Stack, {
      direction: "row",
      justifyContent: "space-between",
      sx: {
        mb: '3px'
      }
    }, /*#__PURE__*/React.createElement(Typography, {
      sx: {
        fontSize: 12.5
      }
    }, reason), /*#__PURE__*/React.createElement(Typography, {
      sx: {
        fontSize: 12.5,
        color: 'text.secondary'
      }
    }, n)), /*#__PURE__*/React.createElement(LinearProgress, {
      variant: "determinate",
      value: n / total * 100,
      sx: {
        height: 5,
        borderRadius: 3
      }
    }));
  })), /*#__PURE__*/React.createElement(Typography, {
    sx: {
      fontSize: 13,
      fontWeight: 600,
      mb: '8px'
    }
  }, "Answers marked not helpful"), worst.length === 0 && /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    color: "text.secondary"
  }, "Nothing rated down yet."), /*#__PURE__*/React.createElement(Stack, {
    spacing: "8px"
  }, worst.slice(0, 25).map(r => /*#__PURE__*/React.createElement(Box, {
    key: "".concat(r.conversationId, "-").concat(r.turnId),
    sx: {
      border: 1,
      borderColor: 'divider',
      borderRadius: '10px',
      p: '12px'
    }
  }, /*#__PURE__*/React.createElement(Stack, {
    direction: "row",
    spacing: "8px",
    alignItems: "center",
    sx: {
      mb: '4px',
      flexWrap: 'wrap',
      rowGap: '6px'
    }
  }, r.reason && /*#__PURE__*/React.createElement(Chip, {
    size: "small",
    label: r.reason,
    variant: "outlined"
  }), r.surface && /*#__PURE__*/React.createElement(Chip, {
    size: "small",
    label: r.surface,
    variant: "outlined"
  }), /*#__PURE__*/React.createElement(Typography, {
    sx: {
      fontSize: 11.5,
      color: 'text.secondary'
    }
  }, new Date(r.at).toLocaleString())), r.note && /*#__PURE__*/React.createElement(Typography, {
    sx: {
      fontSize: 13
    }
  }, r.note), /*#__PURE__*/React.createElement(Typography, {
    sx: {
      fontSize: 11,
      color: 'text.disabled',
      fontFamily: 'monospace'
    }
  }, r.conversationId))))));
}